import React from "react";
import { FormattedMessage } from "react-intl";
import { Card, Row } from "@masterteam/mt-design-react";

import useIsAr from "../../../Hooks/useIsAr";

import { ReactComponent as VisionIcon } from "../../../assets/images/vision.svg";
import { ReactComponent as MissionIcon } from "../../../assets/images/mission.svg";

import styles from "./VisionMission.module.scss";

const VisionMission = ({ strategy }) => {
  const [isAr] = useIsAr();

  return (
    <Row size="large">
      <Card className={`${styles.container}`}>
        <Card className={styles.iconWrapper}>
          <VisionIcon />
          <div className={styles.title}>
            <FormattedMessage id="common.vision" />
          </div>
        </Card>

        <p className={styles.text}>
          {isAr ? strategy?.ArabicVision : strategy?.EnglishVision}
        </p>
      </Card>

      <Card className={`${styles.container}`}>
        <Card className={styles.iconWrapper}>
          <MissionIcon />
          <div className={styles.title}>
            <FormattedMessage id="common.mission" />
          </div>
        </Card>

        <p className={styles.text}>
          {isAr ? strategy?.ArabicMission : strategy?.EnglishMission}
        </p>
      </Card>
    </Row>
  );
};

export default VisionMission;
